import React from "react";
import { useState, useEffect , useContext } from 'react';
import ChartComponent from '../../../../components/chart';
import { Spin } from 'antd';
import Api from "../../../../services/api";
import {getColor,getDates, getBarSize} from '../../../../utility';
import { toast } from 'react-toastify';
import ReChartComponent from "../../../../components/chartNew";

const ChartPlatformCost = (props) => {
  const [loading,setLoading] = useState(false);
	const [chartPlatformRevenue,setChartPlatformRevenue] = useState([]);
  const [chartPlatformRevenueData,setChartPlatformRevenueData] = useState({
  	labels : [],
  	datasets : []
  });
	// const chartPlatformRevenueOptions = {
  //   indexAxis: 'y',
  //   elements: {
  //     bar: {
  //       borderWidth: 2,
  //     }
  //   },
  //   plugins: {
  //     legend: {
  //       display: false,
  //     },
  //     title: {
  //       display: true,
  //       position : "bottom",
  //       text: ''
  //     }
  //   },
  //     responsive: true,
  //     maintainAspectRatio : false,
  //     interaction: {
  //       axis: 'x',
  //       mode: 'index',
  //       intersect: false,
  //     },
  // };

  const chartPlatformRevenueOptions = {
    indexAxis: 'y',
    legend: false
  };

	useEffect(() => {
    setLoading(true)
    Api.get(`api/overview/revenue_by_os?os=${props.os}&from=${props.startDate.format('YYYY-MM-DD')}&to=${props.endDate.format('YYYY-MM-DD')}&code=${props.code}&country=${props.country}&ad_network=${props.adnetwork}&campaign=${props.campaign}&index_filter=${props.filter}`)
    .then(result => {
      if(result?.data?.code === 0){
        setChartPlatformRevenue(result.data.data)
        setLoading(false)
      }
    });
  }, [props.reload, props.filter]);


  useEffect(() => {

    let labels = [];
    let datasets = [{
      label: `${props.startDate.format('YYYY-MM-DD')} - ${props.endDate.format('YYYY-MM-DD')}`,
      data: [],
      backgroundColor: [],
      barThickness : getBarSize
    }];

    chartPlatformRevenue.map((i,k) => {
  		labels.push(i.name)
      datasets[0].data.push(i.value)
      datasets[0].backgroundColor.push(getColor(k))
  	})

    setChartPlatformRevenueData({labels,datasets})
  }, [chartPlatformRevenue]);

  return (
    <Spin spinning={loading}>
      {/* <ChartComponent type="bar" data={chartPlatformRevenueData} options={chartPlatformRevenueOptions} /> */}
      <ReChartComponent type="bar" data={chartPlatformRevenueData} options={chartPlatformRevenueOptions} height={150} />
    </Spin>
  )
}
export default ChartPlatformCost;